(function () {
  const HIDDEN_CLASS = 'hidden';

  document.addEventListener('theme:variant:change', function (event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;

    const root = event.target.closest('product-component') || document;
    const badge = root.querySelector('[data-pdp-save-badge]');
    if (!badge) return;

    const amountEl = badge.querySelector('[data-pdp-save-amount]');
    const comparePrice = variant.compare_at_price;
    const { price } = variant;

    if (!comparePrice || comparePrice <= price) {
      badge.classList.add(HIDDEN_CLASS);
      return;
    }

    if (
      amountEl &&
      window.theme &&
      typeof window.theme.formatMoney === 'function'
    ) {
      amountEl.innerHTML = window.theme.formatMoney(
        comparePrice - price,
        window.theme.moneyFormat,
      );
    }
    badge.classList.remove(HIDDEN_CLASS);
  });
})();
